import React from 'react';

import { formatFoodItemDisplayName } from '../onlineFoodItems';
import '../css/OrderItemsSummary.css';

/** First present value among several possible keys (API casing varies). */
function pick(obj, keys, fallback) {
    for (const k of keys) {
        const v = obj?.[k];
        if (v != null && v !== '') return v;
    }
    return fallback;
}

/**
 * Compact, always-visible list of what to cook for an order:
 * each line shows the QUANTITY first (the number kitchen staff act on), then the
 * item name. Tapping the cell still toggles the full detail row (with price).
 */
const OrderItemsSummary = ({ items, onClick, emptyText = 'No items' }) => {
    const list = Array.isArray(items) ? items : [];

    if (list.length === 0) {
        return <span className="order-items-summary__empty">{emptyText}</span>;
    }

    return (
        <button
            type="button"
            className="order-items-summary"
            onClick={onClick}
            title="Tap for full details"
        >
            {list.map((item, idx) => {
                const name = pick(
                    item,
                    ['foodItemName', 'FoodItemName', 'itemName', 'Food_Item_Name', 'food_item_name'],
                    'Item'
                );
                const displayQty = pick(
                    item,
                    ['displayQuantity', 'display_quantity'],
                    ''
                );
                const qty = pick(
                    item,
                    ['foodQuantity', 'FoodQuantity', 'quantity', 'Quantity', 'food_quantity'],
                    1
                );
                return (
                    <span
                        className="order-items-summary__item"
                        key={item.orderLineId ?? item.order_line_id ?? idx}
                    >
                        <span className="order-items-summary__name">{formatFoodItemDisplayName(name)}</span>
                        <span className="order-items-summary__qty">
                            {displayQty || `×${qty}`}
                        </span>
                    </span>
                );
            })}
        </button>
    );
};

export default OrderItemsSummary;
